<div class="btn-group" role="group" *ngIf="variant === 'semaforo'; else hasErrorTpl">
  <button
    type="button"
    class="btn"
    [ngClass]="{
      'btn-primary': !loading && (navbarLink.isValid$ | async) === true,
      'btn-danger': !loading && (navbarLink.isValid$ | async) === false,
      'btn-secondary': loading || (navbarLink.isValid$ | async) === null
    }"
    [disabled]="forceDisabled || (navbarLink.isDisabled$ | async)"
    [routerLink]="navbarLink.path"
    [routerLinkActive]="activeLinkClass"
    queryParamsHandling="merge"
  >
    {{ navbarLink.title }}
  </button>
  <button
    app-validation-errors-btn
    class="btn"
    [sectionTitle]="navbarLink.title"
    [form]="navbarLink.form"
    [subLinks]="navbarLink.subLinks"
    [isValid$]="navbarLink.isValid$"
    [loading]="loading"
  ></button>
</div>

<ng-template #hasErrorTpl>
  <div class="btn-group" role="group">
    <a
      class="btn btn-primary"
      [routerLink]="navbarLink.path"
      [routerLinkActive]="activeLinkClass"
      #rla="routerLinkActive"
      queryParamsHandling="merge"
      [ngClass]="{
        disabled: forceDisabled || (navbarLink.isDisabled$ | async),
        isLoading: loading,
        hasError: !loading && (!gateErrorByActiveLink || rla.isActive) && (navbarLink.isValid$ | async) === false
      }"
    >
      {{ navbarLink.title }}
    </a>
    <button
      app-validation-errors-btn
      class="btn"
      [sectionTitle]="navbarLink.title"
      [form]="navbarLink.form"
      [isValid$]="navbarLink.isValid$"
      [loading]="loading"
    ></button>
  </div>
</ng-template>
